var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-16"},[_c('div',{staticClass:"blank",style:({backgroundColor:_vm.editablePageConfig.editable_page_config_content.back_color,height:_vm.editablePageConfig.editable_page_config_content.height+'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }